import { styled } from '@mui/material';
import Stack, { type StackProps } from '@mui/material/Stack';
import Typography, { type TypographyProps } from '@mui/material/Typography';

export const ConfirmationStack = styled(Stack)<StackProps>(({ theme }) => ({
  gap: theme.spacing(3),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(3),
  },
}));

export const ConfirmationTitleTypographpy = styled(Typography)<TypographyProps>(
  ({ theme }) => ({
    fontSize: '1.6rem',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.4rem',
    },
  }),
);

export const Title = styled(Stack)<TypographyProps>(({ theme }) => ({
  fontSize: '1.6rem',
  textAlign: 'center',
  [theme.breakpoints.down('sm')]: {
    fontSize: '1.4rem',
  },
}));

export const ErrorPageWrapper = styled(Stack)<StackProps>(({ theme }) => ({
  gap: theme.spacing(3),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(3),
  },
}));

export const VerificationWrapper = styled(Stack)<StackProps>(({ theme }) => ({
  gap: theme.spacing(3),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(3),
  },
}));
